import React from 'react';
import { useSelector } from 'react-redux';
import useConfig from 'hooks/use-config';
import { Box, Flex, Text } from '@spothero/ui';
import { EventListItem } from '../event-empty-state-svg';
import EventEmptyStateSvg from '../event-empty-state-svg/EventEmptyStateSvg';
import { buildSearchUrl } from 'utils/url/search/build-search-url';
import { getRouteParam } from 'utils/url-utils';
import { isEventHappeningToday } from 'pages/search-transient-event-monthly/components/event-list/EventList';
import { GenericListItem } from '../event-list-item/GenericListItem';
const EventContainer = ({ text, testid, children, }) => (<Box data-testid={testid}>
        <Text fontWeight="semibold" fontSize="sm" paddingTop="4" color="text.secondary.light">
            {text}
        </Text>
        {children}
    </Box>);
export const UpcomingEvents = ({ additionalStyle = {}, showBookParkingButton = false, }) => {
    const { siteUrl } = useConfig();
    const partner = useSelector((state) => state.searchRequest.partner);
    const operator_id = useSelector((state) => state.searchRequest.operator_id || getRouteParam('operator_id') // Route param as a backup
    );
    const timezone = useSelector((state) => state.destination.data.timezone);
    const events = useSelector((state) => state.destination.data.events) || [];
    const destinationUrl = useSelector((state) => state.destination.data.relative_url);
    const citySlug = useSelector((state) => state.city.data.slug);
    const redirectToSEOPage = () => {
        const seoUrl = `${siteUrl}/destination/${citySlug}/${destinationUrl}${window.location.search}`;
        window.location.href = seoUrl;
    };
    const mapEventItem = (event, index) => {
        if (event) {
            const { id } = event;
            const eventUrl = buildSearchUrl(siteUrl, {
                kind: 'event',
                id,
                hide_event_modal: true,
                operator_id,
                ...(typeof partner === 'string' && { partner }),
            });
            return (<EventListItem key={id} event={event} eventUrl={eventUrl} index={index} showBookParkingButton={showBookParkingButton}/>);
        }
        return undefined;
    };
    const { happeningTodayEvents, upcomingEvents } = events.reduce((acc, event) => {
        if (isEventHappeningToday(event.starts, timezone)) {
            acc.happeningTodayEvents.push(event);
        }
        else {
            acc.upcomingEvents.push(event);
        }
        return acc;
    }, { happeningTodayEvents: [], upcomingEvents: [] });
    const hasEvents = Boolean(happeningTodayEvents.length || upcomingEvents?.length);
    return (<Box data-testid="UpcomingEvents" {...additionalStyle} flex="1">
            {hasEvents ? (<>
                    {happeningTodayEvents?.length > 0 && (<EventContainer text="Happening today" testid="HappeningTodayEvents-hasEvents">
                            {happeningTodayEvents.map(mapEventItem)}
                        </EventContainer>)}
                    {upcomingEvents?.length > 0 && (<EventContainer text="Coming soon" testid="UpcomingEvents-hasEvents">
                            {upcomingEvents.map(mapEventItem)}
                        </EventContainer>)}
                    <GenericListItem handleClick={redirectToSEOPage} asAnchor={false} data-testid="ViewMoreEvents-button" sx={{
                '&::after': {},
                justifyContent: 'flex-end',
            }}>
                        <Text fontSize="sm" fontWeight="semibold" color="primary.default" mr={2}>
                            View more events
                        </Text>
                    </GenericListItem>
                </>) : (<Flex flexDirection="column" justifyContent="center" alignItems="center" minHeight={60} textAlign="center">
                    <EventEmptyStateSvg />
                    <Text marginTop={4} data-testid="event-upcoming-text">
                        There are no upcoming events at this venue. <br />
                        Please try again later.
                    </Text>
                </Flex>)}
        </Box>);
};
